<template>
  <span class="ebay-category">
    <template v-if="loading">
      <span class="text-muted small">...</span>
    </template>
    <template v-else-if="breadcrumb.length">
      <span
        v-for="(crumb, index) in breadcrumb"
        :key="crumb.category_id"
        class="small"
      >
        <span class="text-muted" v-if="index > 0"> &rsaquo; </span>
        <span :class="{ 'fw-semibold': index === breadcrumb.length - 1 }">{{ crumb.name }}</span>
      </span>
    </template>
    <template v-else>
      <span class="text-muted fst-italic small">Uncategorized</span>
    </template>
  </span>
</template>

<script setup>
import { ref, watch, onMounted, defineProps } from 'vue'
import { useStore } from 'vuex'

// Shared across all instances on the page — avoids duplicate requests for same category
const breadcrumbCache = new Map()

const props = defineProps({
  categoryId: {
    type: Number,
    default: null
  }
})

const store = useStore()
const loading = ref(false)
const breadcrumb = ref([])

async function fetchBreadcrumb(categoryId) {
  if (!categoryId) {
    breadcrumb.value = []
    return
  }

  if (breadcrumbCache.has(categoryId)) {
    breadcrumb.value = breadcrumbCache.get(categoryId)
    return
  }

  loading.value = true
  try {
    const response = await store.state.api.get(`/ebay/category-breadcrumb/${categoryId}`)
    const data = response.data || []
    breadcrumbCache.set(categoryId, data)
    breadcrumb.value = data
  } catch (e) {
    breadcrumb.value = []
  } finally {
    loading.value = false
  }
}

onMounted(() => fetchBreadcrumb(props.categoryId))
watch(() => props.categoryId, (val) => fetchBreadcrumb(val))
</script>
